interface FooterSummaryProps {
  filteredData: any[];
}

const FooterSummary = ({ filteredData }: FooterSummaryProps) => {
  const formatCurrency = (value: number) =>
    value.toLocaleString("bg-BG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getSum = (key: string) =>
    filteredData.reduce((acc, row) => {
      const val = Number(row?.[key] ?? 0);
      return acc + (isNaN(val) ? 0 : val);
    }, 0);

  const totalPremium = getSum("totalSum");
  const gfAmount = getSum("insuranceFundSum");
  const stickerAmount = getSum("stickerSum");
  const agentCommission = getSum("commissionAgentAmount");
  const officeCommission = getSum("commissionOfficeAmount");
  const taxAmount = getSum("twoPercentSum");

  const totalCount = filteredData.length;

  return (
    <div className="mt-2 w-full">
      <div className="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
        <SummaryCard
          label="Обща сума"
          value={formatCurrency(totalPremium)}
          note="(вкл. т.2,т.3,т.4 и т.9)"
        />

        <SummaryCard label="Сума за ГФ" value={formatCurrency(gfAmount)} />

        <SummaryCard
          label="Сума Стикери"
          value={formatCurrency(stickerAmount)}
        />

        <SummaryCard
          label="Комисион за агенти"
          value={formatCurrency(agentCommission)}
          note="(общо)"
        />

        <SummaryCard
          label="Комисион за офиса"
          value={formatCurrency(officeCommission)}
          note="(вкл. Банка/ЗК)"
        />

        <SummaryCard
          label="Сума за данък 2%"
          value={formatCurrency(taxAmount)}
        />
      </div>

      <div className="ml-2 text-[12px] font-semibold text-black dark:text-white">
        Общ брой: <span className="text-meta-3">{totalCount}</span>
      </div>
    </div>
  );
};

const SummaryCard = ({
  label,
  value,
  note,
}: {
  label: string;
  value: string;
  note?: string;
}) => (
  <div className="border-stroke bg-gray-2 dark:border-strokedark dark:bg-meta-4 flex flex-col rounded-sm border p-2">
    <span className="text-[14px] font-medium text-slate-500 dark:text-slate-400">
      {label}
    </span>
    <span className="text-xs font-bold text-black dark:text-white">
      {value}
    </span>
    {note && (
      <span className="text-[8px] text-slate-400 dark:text-slate-500">
        {note}
      </span>
    )}
  </div>
);

export default FooterSummary;
